'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./enums-de2d9d36.js');
var button = require('./button-d7f037ee.js');
var index$4 = require('./index-c25ba35c.js');
var component$n = require('./component-0f14c06d.js');

var PADDING_INDEX = {
    top: 0,
    right: 1,
    bottom: 2,
    left: 3,
};
var Wrapper = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media screen and (min-width: ", ") {\n    min-width: 426px;\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media screen and (min-width: ", ") {\n    min-width: 426px;\n  }\n\n  ",
    ";\n"])), constants.DIMENSIONS.MEDIUM, function (_a) {
    var paddings = _a.paddings, height = _a.height, width = _a.width;
    return "\n    max-width: calc(" + width + " - " + (paddings === null || paddings === void 0 ? void 0 : paddings[PADDING_INDEX.right]) + " - " + (paddings === null || paddings === void 0 ? void 0 : paddings[PADDING_INDEX.left]) + ");\n    min-height: calc(" + height + " - " + (paddings === null || paddings === void 0 ? void 0 : paddings[PADDING_INDEX.top]) + " - " + (paddings === null || paddings === void 0 ? void 0 : paddings[PADDING_INDEX.bottom]) + ");\n    padding: " + (paddings === null || paddings === void 0 ? void 0 : paddings.join(' ')) + ";\n  ";
});
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 500 24px/28px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n  padding-bottom: 40px;\n"], ["\n  font: 500 24px/28px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n  padding-bottom: 40px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Description = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/22px ", ";\n  color: ", ";\n  width: 100%;\n  min-height: 66px;\n  overflow-wrap: break-word;\n"], ["\n  font: 400 14px/22px ", ";\n  color: ", ";\n  width: 100%;\n  min-height: 66px;\n  overflow-wrap: break-word;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledButton = styled__default(button.Button)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  min-height: 30px;\n  margin-right: 12px;\n  background-color: ", ";\n  border: ", ";\n\n  color: ", ";\n  ", "\n"], ["\n  min-height: 30px;\n  margin-right: 12px;\n  background-color: ",
    ";\n  border: ",
    ";\n\n  color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === constants.BUTTON_VARIANT.SECONDARY ? theme.colors.universal.white : theme.colors.primary;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return "1px " + (variant === constants.BUTTON_VARIANT.SECONDARY
        ? theme.colors.greys.sharedDarkGrey
        : theme.colors.primary) + " solid";
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === constants.BUTTON_VARIANT.SECONDARY ? theme.colors.greys.adminGreyDark : theme.colors.universal.white;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return (variant === constants.BUTTON_VARIANT.PRIMARY
        ? "&:hover {\n    background-color: " + theme.colors.primary + ";\n  }\n\n  &:active,\n  &:focus {\n    outline-color: " + theme.colors.primary + ";\n  } "
        : null);
});
var ButtonsWrapper = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n\n  ", ":last-child {\n    margin: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  margin-top: 20px;\n\n  ", ":last-child {\n    margin: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    justify-content: center;\n  }\n"])), StyledButton, constants.DIMENSIONS.MEDIUM);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var DEFAULT_WIDTH = '536px';
var DEFAULT_HEIGHT = '240px';
var DEFAULT_PADDINGS = ['48px', '32px', '48px', '32px'];
var getButtons = function (buttons) { return (React__default.createElement(ButtonsWrapper, null, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (_a) {
    var buttonTitle = _a.title, handler = _a.handler, variant = _a.variant, isLoading = _a.isLoading, disabled = _a.disabled, size = _a.size, dataTestId = _a.dataTestId;
    return (React__default.createElement(StyledButton, { key: buttonTitle, disabled: disabled, onClick: handler, text: buttonTitle, variant: variant || constants.BUTTON_VARIANT.PRIMARY, loading: isLoading, size: size, "data-testid": dataTestId }));
}))); };
var UserDialogModal = function (_a) {
    var isVisible = _a.isVisible, title = _a.title, description = _a.description, buttons = _a.buttons, customSizes = _a.customSizes, exitOnBackgroundClick = _a.exitOnBackgroundClick, onClose = _a.onClose, className = _a.className;
    var buildContent = function () { return (React__default.createElement(Wrapper, { width: (customSizes === null || customSizes === void 0 ? void 0 : customSizes.width) || DEFAULT_WIDTH, height: (customSizes === null || customSizes === void 0 ? void 0 : customSizes.height) || DEFAULT_HEIGHT, paddings: (customSizes === null || customSizes === void 0 ? void 0 : customSizes.paddings) || DEFAULT_PADDINGS, className: className },
        React__default.createElement(Title, { className: className + "-title" }, title),
        description && React__default.createElement(Description, { className: className + "-description" }, description),
        getButtons(buttons))); };
    return (React__default.createElement(component$n.ModalWrapper, { content: buildContent(), visible: isVisible, withExitButton: true, exitOnBackgroundClick: exitOnBackgroundClick, onClose: onClose }));
};
UserDialogModal.propTypes = {
    buttons: index$4.propTypes.arrayOf(index$4.propTypes.any),
};
UserDialogModal.defaultProps = {
    buttons: [],
};

exports.UserDialogModal = UserDialogModal;
